<template>
  <div>
    <table-base
      :columns="columns"
      :items="credentials"
      :pagination="pagination"
      :is-loading="isLoading"
      has-custom-items-template
      :has-no-footer="true"
      :on-select-item="onSelectItem"
      :on-update-pagination="onUpdatePagination"
    >
      <template #item-cell="scope">
        <template v-if="scope.cell.column.value === 'country'">
          <panels-platform :country="scope.cell.item.country" />
        </template>

        <template v-else-if="scope.cell.column.value === 'actions'">
          <div
            class="remove-credential-box"
            @click.prevent.stop="onDeleteClick(scope.cell.item)"
          >
            <v-icon>{{ scope.cell.column.icon }}</v-icon>
          </div>
        </template>

        <template v-else>
          {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
        </template>
      </template>
    </table-base>

    <dialog-confirm
      :text="$t('are_you_sure_you_want_to_delete_this_credential')"
      :is-on="isConfirmDialogOn"
      :is-loading="isDeleting"
      :on-cancel="onCancelDelete"
      :on-confirm="deleteCredential"
    />
  </div>
</template>

<script>
import { extractNestedProp, isNum } from '@/utils';
import columns from '@/config/tracking/columnsCredentials';

export default {
  props: {
    network: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      isDeleting: false,
      isConfirmDialogOn: false,
      credentialForDeletion: null,
      columns,
      pagination: {
        page: 1,
        rowsPerPage: 1000,
        totalItems: 1000,
        sortBy: null,
        descending: false,
      },
    };
  },
  computed: {
    credentials() {
      return this.$store.getters['tracking/networkCredentials'];
    },
  },
  watch: {
    network: {
      handler(newNetwork, oldNetwork) {
        if (isNum(newNetwork?.id) && newNetwork.id !== oldNetwork?.id) {
          this.getCredentials();
        }
      },
      immediate: true,
    },
    '$route'(to, from) {
      if (
        (from.name === 'tracking-networks-new-credentials' || from.name === 'tracking-networks-edit-credentials') &&
        to.name === 'tracking-networks-detail' &&
        to.query?.status === 'success'
      ) {
        this.getCredentials();
      }
    },
  },
  methods: {
    onUpdatePagination({ sortBy, descending }) {
      this.pagination.sortBy = sortBy;
      this.pagination.descending = descending;
    },
    onSelectItem(item) {
      this.$router.push({
        name: 'tracking-networks-edit-credentials',
        params: { id: this.network.id, credentialId: item.id },
      });
    },
    onDeleteClick(item) {
      this.credentialForDeletion = item;
      this.isConfirmDialogOn = true;
    },
    onCancelDelete() {
      this.credentialForDeletion = null;
      this.isConfirmDialogOn = false;
    },
    deleteCredential() {
      this.isDeleting = true;
      this.$store.dispatch('tracking/deleteNetworkCredentials', {
        network_id: this.network.id,
        credential_id: this.credentialForDeletion.id,
      })
        .catch((err) => err)
        .finally(() => {
          this.isDeleting = false;
          this.isConfirmDialogOn = false;
          this.credentialForDeletion = null;
        });
    },
    getCredentials() {
      this.isLoading = true;
      this.$store.dispatch('tracking/getNetworkCredentials', this.network.id)
        .catch((err) => err)
        .finally(() => {
          this.isLoading = false;
        });
    },
    displayColumnValue(item, value) {
      return extractNestedProp(item, value);
    },
  },
};
</script>
